import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  everyoneElse: {
    id: 'proforma-form-security.config-button.config-modal.form-permissions-config.principal-list.everyone-else',
    defaultMessage: 'Everyone else',
    description: 'Displayed when viewing the form permission list to show the permission on everyone else.'
  }
});